// extracted by mini-css-extract-plugin
module.exports = {"box_06":"box_06-3shCt_Xo","clearfix":"clearfix-2_GJNBtw"};